import api from "../../index";

export const GetAllwalletinternalTransferApi = (params) => api.get(`wallet/getall-wallet-internal-transfer?${params}`);
export const InternalTransferRequestAcceptRejectApi = (data) => api.post('trading/internal-withdrawal-approve-reject', data);